import React from 'react'
import IframeResizer from 'iframe-resizer-react'
import config from '../../../config'

const style = {
  width: '100%',
  height: '100%',
  border: 'none',
  display: 'block'
}

const TermsAndConditions = ({countryCode}) => (
  <IframeResizer
    src={config.LANDING_URL + `/${countryCode}/terms`}
    style={style}
    scrolling={true}
  />
)

export default TermsAndConditions



// WEBPACK FOOTER //
// ./src/sections/terms/components/TermsAndConditions.js